/* Game Microsite template – behaviour
   Custom elements re-initialise automatically when a section is re-rendered
   in the Shopify theme editor. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Parallax: any element with data-gm-speed inside <gm-parallax> ----------
     Each section remembers a baseline so all its layers start perfectly aligned,
     whatever sits above it on the page. Parallax is switched off on phones so
     stacked art layers always line up. */
  if (!customElements.get('gm-parallax')) {
    var parallaxEls = new Set();
    var ticking = false;
    var MOBILE = 768;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      var off = window.innerWidth < MOBILE;
      parallaxEls.forEach(function (root) {
        var layers = root.querySelectorAll('[data-gm-speed]');
        if (off) {
          layers.forEach(function (layer) { layer.style.transform = ''; });
          return;
        }
        var rect = root.getBoundingClientRect();
        if (root._gmBase == null) {
          var docTop = rect.top + window.scrollY;
          root._gmBase = docTop < vh ? docTop : vh * 0.5;
        }
        if (rect.bottom < -200 || rect.top > vh + 200) return;
        var y = rect.top + window.scrollY - window.scrollY - root._gmBase;
        y = rect.top - (root._gmBase < vh && root._gmBase === (rect.top + window.scrollY) ? root._gmBase : root._gmBase);
        layers.forEach(function (layer) {
          var speed = parseFloat(layer.dataset.gmSpeed) || 0;
          layer.style.transform = 'translate3d(0,' + (y * speed / -100).toFixed(1) + 'px,0)';
        });
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    function onResize() { parallaxEls.forEach(function (root) { root._gmBase = null; }); onScroll(); }
    if (!reduce) { window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onResize); window.addEventListener('load', onResize); }

    customElements.define('gm-parallax', class extends HTMLElement {
      connectedCallback() { if (!reduce) { this._gmBase = null; parallaxEls.add(this); onScroll(); } }
      disconnectedCallback() { parallaxEls.delete(this); }
    });
  }

  /* ---------- Header: burger, scrolled state, active link, smooth scroll ---------- */
  if (!customElements.get('gm-header')) {
    customElements.define('gm-header', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.burger = this.querySelector('.gm-burger');
        this.menu = this.querySelector('.gm-header__mobile');
        this.bar = this.querySelector('.gm-header');
        if (this.burger) this.burger.addEventListener('click', function () { self.toggle(); });
        this.querySelectorAll('a[href^="#"]').forEach(function (a) {
          a.addEventListener('click', function (e) {
            var id = a.getAttribute('href').slice(1);
            var target = id && document.getElementById(id);
            if (!target) return;
            e.preventDefault();
            self.toggle(false);
            target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
            history.replaceState(null, '', '#' + id);
          });
        });
        this._onScroll = function () { self.bar && self.bar.classList.toggle('is-scrolled', window.scrollY > 40); self.spy(); };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        this._onScroll();
      }
      disconnectedCallback() { window.removeEventListener('scroll', this._onScroll); }
      toggle(force) {
        if (!this.burger) return;
        var open = typeof force === 'boolean' ? force : !this.burger.classList.contains('is-open');
        this.burger.classList.toggle('is-open', open);
        this.burger.setAttribute('aria-expanded', open);
        this.menu.classList.toggle('is-open', open);
        document.documentElement.style.overflow = open ? 'hidden' : '';
      }
      spy() {
        var links = this.querySelectorAll('.gm-header__nav a[href^="#"]');
        var current = null;
        links.forEach(function (a) {
          var el = document.getElementById(a.getAttribute('href').slice(1));
          if (el && el.getBoundingClientRect().top < window.innerHeight * 0.4) current = a;
        });
        links.forEach(function (a) { a.classList.toggle('is-active', a === current); });
      }
    });
  }

  /* ---------- Physical edition image stack ---------- */
  if (!customElements.get('gm-stack')) {
    customElements.define('gm-stack', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.slides = Array.prototype.slice.call(this.querySelectorAll('.gm-stack__slide'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('.gm-dot'));
        this.index = 0;
        var section = this.closest('.gm-physical') || this;
        section.querySelectorAll('[data-gm-prev]').forEach(function (b) { b.addEventListener('click', function () { self.go(self.index - 1); }); });
        section.querySelectorAll('[data-gm-next]').forEach(function (b) { b.addEventListener('click', function () { self.go(self.index + 1); }); });
        this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.go(i); }); });
        this.render();
        var auto = parseInt(this.dataset.autoplay || '0', 10);
        if (auto > 0 && !reduce && this.slides.length > 1) this.timer = setInterval(function () { self.go(self.index + 1); }, auto * 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      go(i) { var n = this.slides.length; if (!n) return; this.index = (i + n) % n; this.render(); }
      render() {
        var n = this.slides.length, self = this;
        this.slides.forEach(function (s, i) {
          var pos = (i - self.index + n) % n;
          s.dataset.pos = pos <= 2 ? String(pos) : 'hidden';
          s.setAttribute('aria-hidden', pos !== 0);
        });
        this.dots.forEach(function (d, i) { d.classList.toggle('is-active', i === self.index); d.setAttribute('aria-current', i === self.index); });
      }
    });
  }

  /* ---------- Media carousel (centre mode, looping) ---------- */
  if (!customElements.get('gm-carousel')) {
    customElements.define('gm-carousel', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.track = this.querySelector('.gm-carousel__track');
        this.viewport = this.querySelector('.gm-carousel__viewport');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('.gm-carousel__slide'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('.gm-dot'));
        this.index = 0;
        var prev = this.querySelector('[data-gm-prev]'), next = this.querySelector('[data-gm-next]');
        if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
        if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
        this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.go(i); }); });
        this.slides.forEach(function (s, i) {
          s.addEventListener('click', function (e) {
            if (i !== self.index) { self.go(i); return; }
            if (e.target.closest('.gm-carousel__play')) self.playVideo(s);
          });
        });
        var startX = null;
        this.viewport.addEventListener('pointerdown', function (e) { startX = e.clientX; });
        this.viewport.addEventListener('pointerup', function (e) {
          if (startX === null) return; var dx = e.clientX - startX; startX = null;
          if (Math.abs(dx) > 40) self.go(self.index + (dx < 0 ? 1 : -1));
        });
        this.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') self.go(self.index - 1);
          if (e.key === 'ArrowRight') self.go(self.index + 1);
        });
        this._onResize = function () { self.render(true); };
        window.addEventListener('resize', this._onResize);
        this.render(true);
      }
      disconnectedCallback() { window.removeEventListener('resize', this._onResize); }
      go(i) {
        var n = this.slides.length; if (!n) return;
        this.stopVideos();
        this.index = (i + n) % n; this.render();
      }
      render(instant) {
        var n = this.slides.length, self = this; if (!n) return;
        var slide = this.slides[this.index];
        var offset = slide.offsetLeft - (this.viewport.clientWidth - slide.offsetWidth) / 2;
        if (instant) this.track.style.transition = 'none';
        this.track.style.transform = 'translate3d(' + (-offset) + 'px,0,0)';
        if (instant) { void this.track.offsetHeight; this.track.style.transition = ''; }
        this.slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === self.index);
          s.classList.toggle('is-prev', i === self.index - 1);
          s.classList.toggle('is-next', i === self.index + 1);
          s.setAttribute('aria-hidden', i !== self.index);
        });
        this.dots.forEach(function (d, i) { d.classList.toggle('is-active', i === self.index); d.setAttribute('aria-current', i === self.index); });
      }
      playVideo(slide) {
        var id = slide.dataset.youtube; if (!id) return;
        var frame = slide.querySelector('.gm-frame');
        frame.innerHTML = '<div class="gm-frame__inner"><iframe src="https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0" title="Video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe></div>';
      }
      stopVideos() {
        this.slides.forEach(function (s) {
          var f = s.querySelector('iframe'); var tpl = s.querySelector('template');
          if (f && tpl) { var frame = s.querySelector('.gm-frame'); frame.innerHTML = ''; frame.appendChild(tpl.content.cloneNode(true)); }
        });
      }
    });
  }
})();
